// Delete
$('input[name="_method"][value="delete"]').parents('a').on('click', function(ev) {
    ev.preventDefault();
    if ($(this).data('confirm') && ! confirm($(this).data('confirm'))) {
        return;
    }
    var $form = $(this).find('form');
    $form.submit();
});

// Toggle tooltips
$('[data-toggle="tooltip"]').tooltip();
$('[data-toggle="tooltip-html"]').tooltip({
    html: true,
});

// Initialize navigation tooltips on page load
initNavTooltips();

// Reinitialize navigation tooltips on window resize
$(window).resize(function() {
    initNavTooltips();
});

// Tooltip copy tracker
$('.copy-tracker').click(function() {
    navigator.clipboard.writeText($(this).parent().prev().html());
    var original = $(this).attr('data-original-title');
    $(this).attr('data-original-title', 'Tracker has been copied');
    $(this).tooltip('show');
    var that = this;
    setTimeout(function()  {
        $(that).tooltip('hide');
        $(that).attr('data-original-title', original);
    }, 3000);
});

// Hide show end date
$('[name="type_id"]').change(function() {
   hideEnddate();
});

$('[name="override_internal_clicks"]').change(function() {
   hideEnddate();
});

// Force submit after pushing enter key
$(document).keypress(function(e) {
    if (e.which == 13 && e.target.hasAttribute('data-submit-form-on-enter')) { //13 for enter key
        var form = e.target.closest('form').submit();
    }
});

// Submit form on change
$('[data-submit-form-on-change]').on('change', function () {
    var form = $(this).closest('form').submit();
});

// Closing and opening sections filter dropdown
document.addEventListener("click", function(event) {
    const dropdown = document.getElementById("filterDropdown");

    if (dropdown && !dropdown.contains(event.target)) {
        handleCollapsibleSections();
    }
});
document.getElementById('filterDropdownBtn')?.addEventListener('click', function() {
    if(this.getAttribute('aria-expanded') == 'true') {
        handleCollapsibleSections();
    }
});

// Hide show publisher fields on the ad create/edit page
document.getElementById('landing_page_url')?.addEventListener('input', function(event) {
    if(! event.target.value) {
        document.getElementById('external_clicks').closest('.form-group').classList.add('d-none');
        document.getElementById('override_internal_clicks').closest('.form-group').classList.add('d-none');
        document.getElementById('distribution-clicks').classList.add('d-none');
    } else {
        document.getElementById('external_clicks').closest('.form-group').classList.remove('d-none');
        document.getElementById('override_internal_clicks').closest('.form-group').classList.remove('d-none');

        if(document.getElementById('override_internal_clicks').checked) {
            document.getElementById('distribution-clicks').classList.remove('d-none');
        }
    }
});

// Select all forms with `data-search` attribute and listen debounded to keyup
let searchTimeout;
document.querySelectorAll("form[data-search]").forEach(searchForm => {
    const searchInput = searchForm.querySelector("input[name='search']");

    if (searchInput) {
        searchInput.addEventListener("keyup", function() {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                searchForm.submit(); // Submit the form
            }, 1250);
        });
    }
});

// Fix choosing type with medium email
$('[name="type_id"]').on('change', function() {
    const medium = $('[name="type_id"] option:selected').data('medium');

    if(medium != 'Email') {
        document.getElementById('opens').closest('.form-group').classList.add('d-none');
    } else {
        document.getElementById('opens').closest('.form-group').classList.remove('d-none');
    }
});

function hideEnddate()
{
    let hasEndDate = $('[name="type_id"] option:selected').data('hasEnddate');

    if($('[name="override_internal_clicks"]').is(':checked')) {
        hasEndDate = true;
    }

    $('[name="end_date"]').parent().toggleClass('d-none', !hasEndDate);
    $('[name="end_date"]').prop('disabled', !hasEndDate);
}

function initNavTooltips() {
    if ($(window).width() >= 992) {
        $('#navbarSupportedContent .nav-link').tooltip();
    } else {
        $('#navbarSupportedContent .nav-link').tooltip('dispose');
    }
}

function handleCollapsibleSections() {
    const sections = document.querySelectorAll('#filterDropdown .collapse');
    sections.forEach(section => {
        const checkboxes = section.querySelectorAll('input[type="checkbox"]');
        if(checkboxes.length == 0) {
            if(document.getElementById('datepicker-placement-date-input').value !== '') {
                section.classList.add('show');
                section.previousElementSibling.setAttribute('aria-expanded', 'true')
                section.previousElementSibling.classList.remove('collapsed');
            } else {
                section.classList.remove('show');
                section.previousElementSibling.setAttribute('aria-expanded', 'false')
                section.previousElementSibling.classList.add('collapsed');
            }

            return;
        }
        const anyChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
        if (!anyChecked) {
            section.classList.remove('show');
            section.previousElementSibling.setAttribute('aria-expanded', 'false')
            section.previousElementSibling.classList.add('collapsed');
        } else {
            section.classList.add('show');
            section.previousElementSibling.setAttribute('aria-expanded', 'true')
            section.previousElementSibling.classList.remove('collapsed');
        }
    });
}

/**
 * Reload page when going backwards and it's cached,
 * to ensure the necessary PHP sessions are set or unset
 * on detail and index pages.
 */
window.onpageshow = function(event) {
    if (event.persisted) {
        window.location.reload();
    }
};